<script>
    import R, {LOADER} from "../lib/requests";
    import {RESERVATION_STATUS} from "../lib/constants";
    import {formatDate} from "../lib/lib";
    import app from "../stores/app";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import TableHeader from "../components/TableHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import ReservationModal from "./ReservationModal.svelte";


    const pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'},
        {id: 'report', name: 'REPORT', link: "/app/reservations-report", icon: 'file-excel'}
    ];

    const tableColumns = [
        {key: 'title', title: 'TITLE', sortable: true},
        {key: 'fullname', title: 'NAME', sortable: true},
        {key: 'price', title: 'PRICE', sortable: true},
        {key: 'payment', title: 'PAYMENT', sortable: true},
        {key: 'payment_type', title: 'PT', sortable: true},
        {key: 'status', title: 'STATUS', sortable: true},
        {key: 'department_id', title: 'DEPARTMENT', sortable: true},
        {key: 'created_at', title: 'DATE', sortable: true, sort_way: 'DESC'},
        {key: '', title: 'TR/RT'},
        {key: '', title: ''},
    ];

    let reservations = null;
    let total = 0;
    let search = {
        limit: 50,
        offset: 0,
        date_from: null,
        date_to: null,
        term: null,
        ref: null,
        order_id: null,
        department_id: null,
        status: RESERVATION_STATUS.NEW,
    };
    let departments = [];
    let selectedId = null;
    let editId = null;
    let page = 1;

    const load = () => {
        const onSuccess = result => {
            if (result.departments) {
                departments = result.departments;
            }
            reservations = result.reservations;
            total = result.total;

            if (search.status === RESERVATION_STATUS.NEW) {
                $app.new_reservations = total;
            }

            parseReservations();
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;
        search.initialize = departments.length == 0 ? 1 : 0;

        R.handle(R.reservation.index, search, onSuccess, onFailure, (reservations == null ? LOADER.PAGE : LOADER.POPUP));
    }

    const parseReservations = () => {
        const payement_types = ["ACC", "CASH", "CPL", "CARD", "BANK"];
        reservations.map(item => {
            let dep = departments.find(x => x.id == item.department_id)
            item.payment_type = payement_types[item.payment_type];
            item.price = item.price || 'request';
            item.payment = item.payment || '';
            item.department_name = dep ? dep.name : '';
            item.created_at = formatDate(item.created_at, 'd-m-y');
            item.total_transfers = ~~item.total_transfers;
            item.total_routes = ~~item.total_routes;
        });
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.date_from = null;
        search.date_to = null;
        search.department_id = null;
        search.term = null;
        search.ref = null;
        search.order_id = null;
        search.status = RESERVATION_STATUS.NEW;

        onSearch();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        page = 1;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onEdit = res => {
        selectedId = res.id;
        editId = res.id;
    }

    const updateList = data => {
        let res = reservations.find(x => x.id == data.id);
        if (res) {
            res.transfer_id = data.transfer_id;
            res.price = data.price;
            res.payment = data.payment;
            res.status = data.status;
            reservations = reservations;
        }
    }

    const closeEdit = data => {
        editId = null;
    }

    const onDelete = res => {
        Alert.delete("Delete", `This will permanently delete reservation from "${res.fullname}".\nAre you sure?`, () => deleteReservation(res.id));
    }

    const deleteReservation = id => {
        const onSuccess = result => {
            load();
            Notifier.showMessage("Reservation deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.reservation.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Reservations" controls={pageHeaderControls} on:reload={load}/>

<div class="panel-simple p-2 pb-0 mb-5">
    <div class="row">
        <div class="col-xl-2 col-6 mb-2">
            <DateControl placeholder="from" bind:value={search.date_from}
                         on:change={onSearch}/>
        </div>
        <div class="col-xl-2 col-6 mb-2">
            <DateControl placeholder="to" bind:value={search.date_to} openRight
                         on:change={onSearch}/>
        </div>
        <div class="col-xl-2 mb-2">
            <select class="form-select" bind:value={search.department_id} on:change={onSearch}>
                <option value={null}>department</option>
                {#each departments as item}
                    <option value="{item.id}">{item.name}</option>
                {/each}
            </select>
        </div>
        <div class="col-xl-2 mb-2">
            <select class="form-select" bind:value={search.status} on:change={onSearch}>
                <option value={null}>-- status --</option>
                <option value={1}>New</option>
                <option value={2}>Completed</option>
                <option value={3}>Failed</option>
                <option value={4}>Canceled</option>
            </select>
        </div>
        <div class="col-xl-2 mb-2">
            <input type="text" class="form-control" bind:value={search.ref} placeholder="ref code" on:change={onSearch}>
        </div>
        <div class="col-xl-2 mb-2">
            <input type="text" class="form-control" bind:value={search.order_id} placeholder="order id"
                   on:change={onSearch}>
        </div>
        <div class="col-xl-8 mb-2">
            <input type="text" class="form-control" bind:value={search.term} placeholder="name, email or phone"
                   on:change={onSearch}>
        </div>
        <div class="col-xl-2 col-6 mb-2">
            <button class="btn btn-default d-block w-100" on:click={clearSearch}>CLEAR</button>
        </div>
        <div class="col-xl-2 col-6">
            <button class="btn btn-outline d-block w-100" on:click={onSearch}>SEARCH</button>
        </div>
    </div>
</div>

{#if reservations}
    {#if reservations.length}
        <div class="table-scroll">
            <table class="table table-list table-list-border mb-4">
                <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                <tbody>
                {#each reservations as item}
                    <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                        <td>
                            <button class="btn-reset is-link text-start"
                                    class:not-active={item.status > RESERVATION_STATUS.COMPLETED}
                                    on:click={() => onEdit(item)}>
                                {item.title}
                            </button>
                            <div class="text-12 text-gray">{item.ref}</div>
                        </td>
                        <td>
                            {item.fullname}
                            <div class="text-12 text-gray">{item.phone}, {item.email}</div>
                        </td>
                        <td class="price-column text-gray text-end">
                            {item.price}
                        </td>
                        <td class="price-column text-gray text-end">
                            {item.payment}
                        </td>
                        <td class="status-column text-gray text-center">
                            {item.payment_type}
                        </td>
                        <td class="status-column text-gray">
                            {#if item.status == RESERVATION_STATUS.COMPLETED}
                                <AppIcon icon="circle-check"/>
                            {:else if item.status > RESERVATION_STATUS.COMPLETED}
                                <AppIcon icon="circle-exclamation-solid"/>
                            {/if}
                        </td>
                        <td class="text-gray">
                            {item.department_name}
                        </td>
                        <td class="date-column text-gray">
                            {item.created_at}
                        </td>
                        <td class="button-column" class:text-danger={item.total_routes>item.total_transfers}
                            class:fw-semibold={item.total_routes>item.total_transfers}>
                            {item.total_transfers}/{item.total_routes}
                        </td>
                        <td class="button-column">
                            <button class="btn-reset btn-tool" title="delete reservation"
                                    on:click={ () => onDelete(item) }>
                                <AppIcon icon="trash" size="16"/>
                            </button>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        </div>
        <Pagination itemsPerPage={search.limit} totalItems={total} page={page} on:change={onPageChange}/>
    {:else}
        <div class="panel-simple panel-pad">
            There are no reservations found
        </div>
    {/if}
{/if}

{#if editId != null}
    <ReservationModal reservation_id={editId} onUpdate={updateList} onClose={closeEdit}/>
{/if}

<style>
    .status-column {
        width: 30px;
    }
</style>